import React from 'react';

import Icon from './square-icons/link.png';

const SquareLinkIcon = () => {
  return <img style={{ height: 30, width: 30 }} src={Icon} alt="link-icon" />;
};

export default SquareLinkIcon;
